import { Stack, Typography } from "@mui/material";

export default function InfoRateio({
    resposta
}: InfoRateioProps) {

    const { add_rateio, rateios } = resposta

    return (
        <Stack>
            <Typography variant="caption" component='div' my={0.5}>Adicionar Rateio: <b>{add_rateio === "true" ? "Sim" : "Não"}</b></Typography>
            {
                rateios?.length > 0 && rateios.map((rateio, index) => (
                    <Typography key={index} variant="caption" component='div' my={0.5}>
                    <b>{`${rateio.contaDevedora.codigo_contabil} - ${rateio.contaDevedora.nome} | Valor: ${rateio.valor}`}</b>
                    {
                        rateio.contaDevedora.centro_custo &&
                        <Typography component='div' color="text.secondary" my={0.5} fontSize={11}><b>{`${rateio.contaDevedora.centro_custo.id} - ${rateio.contaDevedora.centro_custo.nome}`}</b></Typography>
                    }
                    </Typography>
                ))
            }
        </Stack>
    )
}

interface InfoRateioProps {
    resposta: RespostaRateio
}

interface RespostaRateio {
    add_rateio: string;
    rateios: Rateio[];
}

interface ContaDevedora {
    id: number;
    conta_contabil: string;
    conta_contabil_formatada: string;
    codigo_contabil: number;
    nome: string;
    natureza: string;
    sistema_xy: string | null;
    tipo: string;
    centro_custo: CentroCusto;
    centro_custos: any | null;
}

interface Rateio {
    contaDevedora: ContaDevedora;
    valor: string;
}

interface CentroCusto {
    id: number;
    nome: string;
};


